<template>
  <el-dialog
    append-to-body
    title="欢迎登录!"
    :visible="visible"
    width="500px"
    custom-class="loginDialog"
    :close="close"
    :close-on-click-modal="false"
    :before-close="close"
  >
    <el-form
      :model="loginForm"
      :rules="rules"
      ref="loginForm"
      style="margin: 0 auto; width: 400px"
      label-width="70px"
    >
      <el-form-item label="用户名" prop="username">
        <el-input
          v-model="loginForm.username"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
          v-model="loginForm.password"
          placeholder="请输入密码"
          :type="showPassword ? 'text' : 'password'"
        >
          <img
            slot="suffix"
            v-if="!showPassword"
            @click="showPassword = !showPassword"
            class="eye-icon"
            src="@/assets/common/eye-close.png"
          />
          <img
            slot="suffix"
            v-else
            @click="showPassword = !showPassword"
            class="eye-icon"
            src="@/assets/common/eye-open.png"
          />
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="small"
          :loading="loading"
          style="width: 100%; margin-top: 10px"
          @click="login"
          >登 录</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { login, getCodeImg } from "@/api/user";
import { setToken } from "@/utils/token";
export default {
  name: "LoginDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(val) {
      if(val) {
        this.$nextTick(() => {
          this.$refs.loginForm.resetFields();
        })
      }
    }
  },
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        code: "",
        uuid: "",
      },
      codeUrl: "",
      showPassword: false,
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      loading: false,
    };
  },
  created() {
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
      if (!this.$store.state.user.isLogin && this.$route.meta?.requireAuth) {
        this.$router.back();
      }
    },
    // getCode() {
    //   getCodeImg().then((res) => {
    //     console.log("res", res);
    //     this.codeUrl = "data:image/gif;base64," + res.img;
    //     this.loginForm.uuid = res.uuid;
    //   });
    // },
    login() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          // 登录
          this.loading = true;
          login(this.loginForm)
            .then(async(res) => {
              setToken(res.token);
             await this.$store.dispatch("getUserInfo");
              this.close();
              this.loading = false;
              this.$store.commit('RELOAD_PAGE')
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped lang="less" >
.eye-icon {
  cursor: pointer;
  width: 15px;
  margin-right: 5px;
}
</style>